import * as React from 'react';
import { createElement } from 'react';
import { Select } from '@alifd/next';
import wrapper from './next-wrapper';
import request from '@/utils/request';
import TitleTooltip from '@/components/table/pro-table/components/tooltip-title';
const UniqueCodeSelect = (props, ref) => {
    const uniqueCodeMapRef = React.useRef(new Map());
    const [dataSource, setDataSource] = React.useState([]);
    const { dict: uniqueCodeArray, __designMode, value, showTitleTooltip, hasClear = true, showSearch = true, ...restProps } = props;
    const uniqueCode = uniqueCodeArray?.[uniqueCodeArray?.length - 1];
    const isDesign = __designMode === 'design';
    const queryList = async (uniqueCode) => {
        const { content = [] } = await request.get('/api/process/field/summary', {
            params: { type: uniqueCode },
        });
        const dataSource = content.map(({ id, name }) => ({
            name,
            id,
        }));
        uniqueCodeMapRef.current.set(uniqueCode, dataSource);
        localStorage.setItem('uniqueCodeMap', JSON.stringify(Array.from(uniqueCodeMapRef.current.entries())));
        setDataSource(dataSource);
    };
    React.useEffect(() => {
        if (isDesign) {
            return;
        }
        const dictMap = new Map(JSON.parse(localStorage.getItem('uniqueCodeMap')));
        uniqueCodeMapRef.current = dictMap;
        if (dictMap.size === 0) {
            queryList(uniqueCode);
        }
        else {
            const foundCache = uniqueCodeMapRef.current.get(uniqueCode);
            if (foundCache) {
                setDataSource(foundCache);
            }
            else {
                queryList(uniqueCode);
            }
        }
    }, [uniqueCode, isDesign]);
    const renderPreview = () => {
        const val = dataSource.find((item) => item.id === value)?.name;
        if (showTitleTooltip) {
            return createElement(TitleTooltip, null, val);
        }
        return createElement("span", null, val);
    };
    return (createElement(Select, { ...restProps, ref: ref, dataSource: dataSource?.map(({ name: label, id: value }) => ({ label, value })), renderPreview: renderPreview, showSearch: showSearch, hasClear: hasClear }));
};
export const UniqueCodeSelectRef = React.forwardRef(UniqueCodeSelect);
const UniqueCodeDictSelect = wrapper(UniqueCodeSelectRef, 'CbayelUniqueCodeDictSelect');
export default UniqueCodeDictSelect;
